var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { minWidthMedia } from "@irati/ui/src/global/media";
import { TROPHY_SIZE } from "../constants";
var TrophyWrapper = styled("div")(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  ", "\n  ", "\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  ",
    "\n  ",
    "\n"])), minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n  "], ["\n    position: relative;\n  "]))), function (_a) {
    var isTrophySelected = _a.isTrophySelected;
    return !isTrophySelected && "\n    transition: width 0.5s ease;\n    width: " + TROPHY_SIZE + "px;\n    margin-left: 20px;\n    justify-content: flex-start;\n  ";
});
export default TrophyWrapper;
var templateObject_1, templateObject_2;
